import { useEffect, useState } from "react";
import { getTeamMemberDaysRequested } from "../../../../../services/vacation.service";

/**
 * Hook para obtener el resumen de días de vacaciones solicitados por el miembro del equipo
 * @param {Object} [filters] - Filtros para la consulta
 * @param {string} [filters.startDate=null] - Fecha de inicio en formato ISO (YYYY-MM-DD) ej: "2026-02-28"
 * @param {string} [filters.endDate=null] - Fecha de fin en formato ISO (YYYY-MM-DD) ej: "2026-02-28"  
 * @param {boolean} [filters.withRange=false] - Si se usa rango de fechas. Si es false, obtiene el período del año actual
 * @param {boolean} [filters.refresh=false] - Bandera para forzar actualización de datos cuando cambia
 * @returns {Object} Objeto con takenDaysResume (resumen de días) e isLoading (estado de carga)
 */
export default function useTeamMemberTakenDaysResume(filters = { startDate: null, endDate: null, withRange: false, refresh: false }) {
    const [takenDaysResume, setTakenDaysResume] = useState({
        pendingBucketDays: 0,
        pendingPlusDays: 0,
        pendingAccordedDays: 0,
        pendingAdditionalDays: 0,
        approvedBucketDays: 0,
        approvedPlusDays: 0,
        approvedAccordedDays: 0,
        approvedAdditionalDays: 0,
        requestedTotal: 0
    })

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const validFilters = filters.withRange ? filters.startDate && filters.endDate : true
        if(validFilters){
            getData()
        }
    },[filters])

    const getData = async () => {
        try {
            setIsLoading(true)
            const { success, result } = await getTeamMemberDaysRequested(filters)

            if (!success) return
            setTakenDaysResume({
                pendingBucketDays: result.pendingBucketDays,
                pendingPlusDays: result.pendingPlusDays,
                pendingAccordedDays: result.pendingAccordedDays,
                pendingAdditionalDays: result.pendingAdditionalDays,
                approvedBucketDays: result.approvedBucketDays,
                approvedPlusDays: result.approvedPlusDays,
                approvedAccordedDays: result.approvedAccordedDays,
                approvedAdditionalDays: result.approvedAdditionalDays,
                requestedTotal: result.requestedTotal
            })
        } catch (error) {
            console.error("Error fetching team member taken days resume:", error)
        } finally {
            setIsLoading(false)
        }
    }

    return { takenDaysResume, isLoading }
}